import accountStyles from "../../common/css/Account.module.css"
const AccountWrap = ({children}) => {
    return (
        <div className={accountStyles.account_wrap}>{children}</div>
    );
};

export default AccountWrap;